import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/management",
		component: lazy(() => import("./CarrierUsersPage")),
	},
]);
